import { apiNiches } from "services";
import { toast } from "react-hot-toast";

export const updateNiches = async (gifId: string, selected: string[], onSuccess: () => void) => {
  try {
    await apiNiches.setGifNiches({ gifId, nicheIds: selected });
    toast.success("Gif niches updated.");
    onSuccess();
  } catch (e) {
    console.error(`Could not set gif niches: ${e}`);
    toast.error("Could not save niches, please try again.");
  }
};
